import { render, staticRenderFns } from "./intro-component.vue?vue&type=template&id=a833860c&scoped=true&"
import script from "./intro-component.vue?vue&type=script&lang=ts&"
export * from "./intro-component.vue?vue&type=script&lang=ts&"
import style0 from "./intro-component.vue?vue&type=style&index=0&id=a833860c&lang=scss&scoped=true&"
import style1 from "./intro-component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a833860c",
  null
  
)

export default component.exports